import PropTypes from 'prop-types';

import MultiColumnLayout from '../MultiColumnLayout';

export const ProductCards = ({ data = null }) => {
  return <MultiColumnLayout data={data} componentType="product-card" />;
};

ProductCards.propTypes = {
  data: PropTypes.shape(),
};
